module.exports = __webpack_public_path__ + "media/images/online_ordering_settings_images/close-baa8c5d873c1a179ca7683c05dfa3685.png";